export default () => ({
  featureGroupContainer: { marginBottom: '1.5rem' },
  card: { height: '100%' },
  cardHeader: {
    display: 'flex',
    padding: '16',
    alignItems: 'end',
  },
  avatar: { marginTop: 10 },
});
